export enum EPartnerStoresStructureType{
    MultiStoreSelectionModel,
    SingleStoreModel,
    StoreAgnosticModel
}